import React, { Component, Fragment } from 'react';
import { connect, batch } from 'react-redux';
//Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

// Component
import MultiSelectResponse from './MultiSelectResponse/MultiSelectResponse';
import MultiSelectImageResponse from "./MultiSelectResponse/MultiSelectImageResponse";

import ItemSection from '../../Section/ItemSection';

import { processResponse, processItemResponse } from '../../../../utilities/processResponse';

//Assets

import '../MultiSelectItem/MultiSelectItem.css';

// Actions
import { getQuestionList, resetSingleItemSlider } from '../../../../actions/SurveyAction';

import { isMobile, isTablet } from 'react-device-detect';

class MultiSelectItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderValue:null,
            undoIcon:false,
            naCheck:false,
            resetCheckedValue:null,
        }

        this.restoreSingleItemArr = [];
    }

    componentDidUpdate(prevProps) {
        var questionId = this.props.scrollToQuestionId;

        if (questionId !== null) {
            if (this.props.scrollToQuestionId !== prevProps.scrollToQuestionId) {
                this.scrollToQuestion(questionId);
            }
        }
    }

    resetAllSingleItem = (event, configuration, rateeKey, naType) => {
        const { questionItemList, dispatch } = this.props;

        const { key } = configuration;
        const itemTagKey = key;
        var itemList = questionItemList[key];
        /* Get the element based on question */
        var nodeList = document.getElementsByClassName(`MultiSelect_${itemTagKey}`);
        // var nodeDropDown = document.getElementsByClassName(`MultiSelectDropDown_${itemTagKey}`);

        itemList.filter((items, i) => {

            if (items.key === itemTagKey) {

                if (items.itemResponses.length > 0) {
                    this.restoreSingleItemArr = items.itemResponses;
                    this.setState({undoIcon:true});
                }


                if (naType === "clear" || typeof naType === "boolean") {
                    items.itemResponses = [];
                    items.isAnswer = false;
                    items.isRequired = false;

                    if (naType !== "clear") {
                        this.handleNaDisabled(naType, itemTagKey, questionItemList);
                        items.isNA = naType === false ? false : true;
                    }

                } else {
                    items.itemResponses = this.restoreSingleItemArr;
                    items.isAnswer = true;
                    items.isRequired = false;
                    items.isNA = false;
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];

                            if (element.checked) {
                                element.checked = false;
                            } else {
                                element.disabled = false;
                            }
                        }
                    }
                    this.setState({undoIcon:false});
                }
            }
            return true;
        });
        batch(() => {
            dispatch(getQuestionList(questionItemList));
        });
    }

    handleNaDisabled = (naType, itemTagKey, questionItemList) => {
        var scrollDiv = document.getElementById(`ScrollDiv_${itemTagKey}`);

        scrollDiv.style.fontStyle = naType === false ? 'normal' :'italic';
        scrollDiv.style.color = naType === false ? '#0f5ea0' :'#8787';
        batch(() => {
            this.props.dispatch(getQuestionList(questionItemList));
        });
    }

    /**
     * Method to scroll respective element based on id
     *
     * @param { questionId:string }
     *
     */
    scrollToQuestion = (questionId) => {
        var scrollDiv = document.getElementById("ScrollDiv_" + questionId);
            scrollDiv.style.paddingTop = "40px";;
            scrollDiv.scrollIntoView({top:scrollDiv.offsetTop, behavior:"smooth"});
    }

    renderRangeSlider(responseConfiguration) {
        const { configuration } = this.props;

        let uniqueId = [this.currentRatee.key, configuration.key, responseConfiguration.response].join(":");
        let buttonGroup = [this.currentRatee.key, configuration.key].join(":");
        let key = this.currentRatee.key;

        return (
            <td key={uniqueId} >
            </td>
        );
    }

    renderRangeSliderGroup(ratee, me) {
        const { configuration } = this.props;
        this.currentRatee = ratee;
        this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(":");
        return configuration.layoutHints === "slider" || configuration.layoutHints === "singleselectdropdown" && configuration.scale != null && configuration.scale.scaleResponses != null ? this.renderRangeSlider(configuration, this): configuration.scale.scaleResponses.map(this.renderRangeSlider, this)
    }

    /**
     * Method to load spinner image
     *
     */
    renderSpinner = (configuration) => {
        return <i className={`fa fa-spinner fa-spin fa_${configuration.key}`} style={{"fontSize":"25px", "display":"none"}}></i>
    }

    /**
     * N/A check box functionality
     *
     */
    naSingleSelectCheck = (event, configuration) => {
        try {
            var itemKey = configuration.key;
            var naCheck = event.target.checked;
            var surveyItem = document.getElementById(`survey-item-block_${itemKey}`);
            this.setState({naCheck:naCheck});

            if (naCheck) {
                surveyItem.style.background = "#F2F2F2";
                surveyItem.style.color = "#ACACAC";
                var responseSet = this.props.itemResponses[itemKey] = {};
                var itemResponses = [{
                    "itemType"     : configuration.itemType,
                    "buttonGroup"  : null,
                    "sequence"     : 1,
                    "isNa"         : naCheck,
                    "response"     : null,
                    "responseValue": null,
                    "openEnd"      : null,
                    "serverStatus" : 0,
                    "hasPosted"    : 0
                }];

                processItemResponse(itemKey, responseSet, itemResponses);
                this.props.handleItemResponse(configuration.key, this.props.itemResponses, "itemChange");
            } else {
                surveyItem.style.background = "#fff";
                surveyItem.style.color = "#000";
            }

            this.resetAllSingleItem(null, configuration, null, naCheck);
        } catch (error) {
            console.log("Exception: while check n/a checkbox in single select:_", error);
        }
    }

    /**
     * Restore value before selected
     *
     */
    resetSingleSelectResponse = (event, configuration) => {
        const { dispatch } = this.props;
        const layOutHints = configuration.layoutHints;
        var sliderRestoreValue = this.restoreSingleItemArr[0].responseValue;

        if (layOutHints === "slider") {
            dispatch(resetSingleItemSlider(sliderRestoreValue))
        }
        this.resetAllSingleItem(null, configuration, null, "reset");
    }

    renderView = (configuration, rateeKey) => {
        const { questionItemList, pageInstrumentConfiguration, itemResponses, itemTempResponses, assessmentInfosForDataCollection, dataCollectionGuid, horizontalAlignment, dependencies, pageList, pageNumber, activePageKey, survey, activePageNumber, nextPageKey } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey].scaleResponses;
        const renderingHint = scales[configuration.scaleKey].renderingHint;
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        if (renderingHint !== "captcha") {
            return scaleResponses.map((responseConfiguration, i) => {
                return <MultiSelectResponse
                    key={responseConfiguration.key}
                    itemKey={scales[configuration.scaleKey].key}
                    multiSelectItemConfiguration={scales[configuration.scaleKey]}
                    className={scales[configuration.scaleKey].className}
                    configuration={responseConfiguration}
                    itemProperties={scales[configuration.scaleKey]}
                    pageInstrumentConfiguration={pageInstrumentConfiguration}
                    id={responseConfiguration.key}
                    buttonGroup={configuration.key}
                    dependencies={dependencies}
                    pageList={pageList}
                    survey={survey}
                    activePageKey={activePageKey}
                    nextPageKey={nextPageKey}
                    activePageNumber={activePageNumber}
                    pageNumber={pageNumber}
                    items={configuration}
                    itemResponses={itemResponses}
                    itemTempResponses={itemTempResponses}
                    handleRequired={() => this.props.handleRequired()}
                    handleItemResponse={(itemKey, itemResponsesSet, type, dataGuid) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuid)}
                    questionItemList={questionItemList}
                    rateeKey={dataCollectionGuid}
                    ratees={assessmentObj}
                    horizontalAlignment={horizontalAlignment}
                    putAllForItemCollection={this.props.putAllForItemCollection}
                    index={i}
                    handleDynamicDependency={(checkboxAnswer,depKey,response,pageDep,reqInd)=>this.props.handleDynamicDependency(checkboxAnswer,depKey,response,pageDep, reqInd)}
                    handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
                />
            })
         } else {
            return <MultiSelectImageResponse
                    itemKey={scales[configuration.scaleKey].key}
                    singleSelectImageItemConfiguration={scales[configuration.scaleKey]}
                    className={scales[configuration.scaleKey].className}
                    itemProperties={scales[configuration.scaleKey]}
                    configuration={scaleResponses}
                    buttonGroup={configuration.key}
                    dependencies={dependencies}
                    items={configuration}
                    itemResponses={itemResponses}
                    itemTempResponses={itemTempResponses}
                    onNextButtonClickTest={(num, type, activePageNumber) =>
                        this.props.onNextButtonClick(num, type, activePageNumber)
                    }
                    handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) =>
                        this.props.handleItemResponse(
                            itemKey,
                            itemResponsesSet,
                            type,
                            dataGuidId
                        )
                    }
                    pageList={pageList}
                    survey={survey}
                    activePageKey={activePageKey}
                    pageNumber={pageNumber}
                    questionItemList={questionItemList}
                    ratees={assessmentObj}
                    rateeKey={dataCollectionGuid}
                    horizontalAlignment={horizontalAlignment}
                    putAllForItemCollection={this.props.putAllForItemCollection}
                />
        }
    }

    componentWillUnmount() {
        this.restoreSingleItemArr = [];
    }

    render() {
        const { configuration, ratees, questionItemList, pageInstrumentConfiguration } = this.props;
        const { scales, itemNaUncheckedButtonKey, itemResetButtonKey, itemRestoreButtonKey, buttons, sections, properties } = pageInstrumentConfiguration;
        var singleItemIcon = [];
        var scaleKey = configuration.scaleKey;

        singleItemIcon = questionItemList.filter((item, i) => {
            if (item.key === configuration.key ) {
                return item.userResponse.length || 0;
            }
            return null;
        });

        var naResponse = scales[scaleKey].naResponse || null;
        var jsx = '';
        var rateeKey = null;

        for (const key in ratees) {
            if (ratees.hasOwnProperty(key)) {
                const element = ratees[key];
                rateeKey = element.key;
            }
        }
        let OSName = "Unknown OS";
        if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
        if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
        if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
        if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
        if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
        var groupIconsClass = configuration.hasItemResetButton || configuration.hasItemRestoreButton || naResponse !== null ? "ItemGroupIcon" : null;

        if (ratees.length < 2) {
            jsx = (
                <Fragment>
                    <div data-id={configuration.key} name={`survey-item-block`} id={`survey-item-block_${configuration.key}`} className={`survey-item-block survey-item-block_${configuration.key}`} style={(isMobile || isTablet) && OSName == "Android" ? {position:'relative', top:29} : null} >
                        <Row id={`ScrollDiv_${configuration.key}`} className={`_ItemTextCss ${configuration.cssClass !== null ? configuration.cssClass:""}`}>
                        {
                            configuration.itemText !== null ?
                                <>
                                    <Col xs={1}>
                                        <div className={"ItemSpinner"}>
                                            { this.renderSpinner(configuration) }
                                        </div>
                                    </Col>
                                    <Col
                                        xs={naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? 10 : 10}
                                        className="itemText"
                                    >
                                        {configuration.isRequiredLabel === true ? <span className={"_AsteriskMark"}>{properties.requiredIndicator}</span> :''}
                                        <span className="itemTag" dangerouslySetInnerHTML={{__html:processResponse(configuration.itemTag)}}></span>
                                        <span dangerouslySetInnerHTML={{__html: processResponse(configuration.itemText)}}></span>
                                    </Col>
                                    <Col xs={1}></Col>
                                </>
                            :null
                        }
                            <Col
                                xs={1}
                                className={groupIconsClass}
                                style={{display: naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? "block":"none"}}
                            >
                                {naResponse !== null && naResponse !== undefined ? <span>
                                    <Form.Check
                                        className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                        type="checkbox"
                                        onChange={(event) => this.naSingleSelectCheck(event, configuration)}
                                    />
                                    <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
                                </span>:null}
                                {configuration.hasItemResetButton ?
                                <span
                                    className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                                    onClick={(event) => this.resetAllSingleItem(event, configuration, rateeKey, "clear")}
                                >
                                    {
                                        singleItemIcon.length > 0 && this.state.undoIcon === false ?
                                            <i className={buttons[itemResetButtonKey].buttonFontAwesome}></i>
                                        :
                                        null
                                    }
                                </span> : null}
                                {configuration.hasItemRestoreButton ?
                                    <span
                                        className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetSingleSelectResponse(event, configuration)}
                                    >
                                    {
                                        this.state.undoIcon === true && this.state.naCheck === false ?
                                        <i className={buttons[itemRestoreButtonKey].buttonFontAwesome}></i>
                                        : null
                                    }
                                </span> : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={1}>
                                <div className={"ItemSpinner"}>
                                    { this.renderSpinner(configuration) }
                                </div>
                            </Col>
                            <Col xs={10}>
                                {configuration.itemPreSectionKey !== null && sections.hasOwnProperty(configuration.itemPreSectionKey) ?
                                    <ItemSection
                                        key={sections[configuration.itemPreSectionKey].key}
                                        type="itemPreSection"
                                        html={sections[configuration.itemPreSectionKey].content}
                                        className={sections[configuration.itemPreSectionKey].className !== null ? sections[configuration.itemPreSectionKey].className:""}

                                />: null}
                            </Col>
                            <Col xs={1}></Col>
                        </Row>
                        <Row key={configuration.key} >
                            <Col xs={1}></Col>
                            <Col xs={10}
                                className={configuration.layoutHints === "slider" ? "single-select-item-slider":
                                configuration.layoutHints === "radioHorizontal" ? "single-select-item-radio-horizontal":configuration.layoutHints === "singleBox" ? "single-select-box-block":`_LIS_Item ${configuration.cssClass !== null ? configuration.cssClass:""}`}
                            >
                                {this.renderView(configuration, rateeKey)}
                            </Col>
                            <Col xs={1}></Col>
                        </Row>
                        <Row>
                            <Col xs={1}></Col>
                            <Col xs={10}>
                                {configuration.itemPostSectionKey !== null && sections.hasOwnProperty(configuration.itemPostSectionKey) ?
                                    <ItemSection
                                        key={sections[configuration.itemPostSectionKey].key}
                                        type="itemPostSection"
                                        html={sections[configuration.itemPostSectionKey].content}
                                        className={sections[configuration.itemPostSectionKey].className !== null ? sections[configuration.itemPostSectionKey].className:""}
                                />: null}
                            </Col>
                        </Row>
                    </div>
                </Fragment>
            );
        } else {
            jsx = (
                <div className='SingleSelectItem SingleOrMultiSelectItem'>
                    <div className='PreItemTextDiv'>
                    </div>
                    <div id={`ScrollDiv_${configuration.itemTag}`} className='ItemTagItemText'>
                        <div className='ItemTag' dangerouslySetInnerHTML={{__html:configuration.itemTag}}></div>
                        <div className='ItemTagTextHorizontalSpacer'>
                            {configuration.isRequired === true ? <span className="Error_isRequired">*</span> :''}
                        </div>
                        <div className='ItemText' dangerouslySetInnerHTML={{__html: configuration.itemText}}></div>
                        <div className='clearButton'>
                            <button onClick={(event) => this.resetAllSingleItem(event, configuration, rateeKey)}>Clear</button>
                        </div>
                    </div>
                    { configuration.isPlaceholder === true ? <div className='PostItemTextDiv'>This is placeholder</div>: null }
                    <div className='SingleOrMultiSelectGroup'>
                        <table id="table">
                            <tbody>
                            { configuration.layoutHints === "slider" || configuration.layoutHints === "singleselectdropdown" ? null:
                                <tr>
                                    <th colSpan="1"></th>
									{
										configuration.scale != null && configuration.scale.scaleResponses != null ? configuration.scale.scaleResponses.map(responseConfiguration => {
											return <th key={responseConfiguration.key} dangerouslySetInnerHTML={{__html: responseConfiguration.responseDescription}}></th>;
										}) : null
									}
                                </tr>

                            }
							{ratees != null ? ratees.map(ratee => {
									return (
										<tr key={ratee.dataCollectionGuid}>
											<td className='RateeName' title={ratee.relationshipDescription}>
												{ratee.participantName}
											</td>
											{/* {this.renderRangeSliderGroup(ratee, this)} */}
										</tr>
									);
								}, this) : null
							}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        return jsx;
    }
}

const mapStateToProps = state => ({
    scrollToQuestionId:state.survey.scrollToQuestionId,
    answeredQuestionCount:state.survey.answeredQuestionCount,
    assessmentInfosForDataCollection:state.survey.assessmentInfoDataCollectionData
});

export default connect(mapStateToProps)(MultiSelectItem);
